import React, { ReactNode } from "react";

const BulletList = ({ children }: { children?: ReactNode }) => (
  <ul className="list-disc list-outside mb-4 ml-4 space-y-1">{children}</ul>
);

export default BulletList;
